import { EventReportBooking } from '@components/customers/customers-table-expandable/src/customers-table-expandable.type';
import { EventReportBookingOptions } from '@contexts/event-report/event-report-context.type';
import { useGenericInfiniteQuery } from '@hooks/use-generic-infinite-query';
import { Params, paramsSerializer } from '@utils/format-params';
import { request } from '@utils/request/request';
import { RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

export interface EventBookingParams {
  from?: number;
  to?: number;
  orderBy?: string;
  sort?: string;
  offset?: number;
  limit?: number;
  search?: string;
  channels?: string[];
  offers?: string[];
  addOns?: string[];
  salesMode?: string;
  isRefunded?: boolean;
  hasCheckedIn?: boolean;
  booking?: EventReportBookingOptions;
}
export interface CustomerListRequestParams {
  eventId: string;
  params: EventBookingParams;
}

const getEventBookings = async ({ eventId, params }: CustomerListRequestParams) => {
  const queryParams = paramsSerializer(params as Params);
  const endpoint = `/v1/nightgraph/events/${eventId}/bookings?${queryParams}`;
  const url = `${import.meta.env.VITE_MONOLITH_HOST}${endpoint}`;
  return request({ url, method: RequestMethod.GET });
};

export interface EventBookingProps {
  eventId: string;
  params: EventBookingParams;
  options?: Record<string, unknown>;
}

export const useGetEventBookings = ({ eventId, params, options }: EventBookingProps) => {
  const limit = params.limit ?? 100;

  const info = useGenericInfiniteQuery<EventReportBooking[]>(
    [
      QUERY_KEYS.getEventBookings,
      eventId,
      params.from,
      params.to,
      params.orderBy,
      params.sort,
      params.limit,
      params.search,
      params.channels,
      params.offers,
      params.addOns,
      params.isRefunded,
      params.salesMode,
      params.hasCheckedIn,
    ],
    ({ pageParam }) => getEventBookings({ eventId, params: { ...params, limit, offset: pageParam ?? 0 } }),
    {
      ...options,
      getNextPageParam: (lastPage, allPages) => (lastPage.length === limit ? allPages.length * limit : false),
    },
    false
  );
  return info;
};
